import { render } from "./hand-16.vue?vue&type=template&id=aea48d3a&scoped=true"
import script from "./hand-16.vue?vue&type=script&lang=js"
export * from "./hand-16.vue?vue&type=script&lang=js"

import "./hand-16.vue?vue&type=style&index=0&id=aea48d3a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea48d3a"]])

export default __exports__